import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
export function QueEsSection() {
  const [ref, isInView] = useInView({
    threshold: 0.2
  });
  return <section id="que-es" className="py-16 sm:py-32 relative overflow-hidden bg-[#0c0c0e] border-t border-white/5 scroll-mt-[56px] sm:scroll-mt-[70px]" data-id="element-640">
      <div className="absolute top-0 right-0 w-full max-w-2xl h-full bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.05),transparent_50%)] pointer-events-none" data-id="element-641" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-642">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="flex flex-col gap-12 max-w-3xl mx-auto text-center" data-id="element-643">
          <div data-id="element-644">
            <span className="inline-block text-gold text-[10px] sm:text-xs font-bold tracking-[3px] uppercase mb-4" data-id="element-645">
              La experiencia
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black text-white mb-8 leading-tight" data-id="element-646">
              ¿Qué incluye <span className="text-gold" data-id="element-647">esta experiencia?</span>
            </h2>

            <div className="space-y-5 text-base sm:text-lg text-white/80 font-medium leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-648">
              <p data-id="element-649">
                El Código 888 es una{' '}
                <span className="text-white font-bold" data-id="element-650">
                  biblioteca digital privada
                </span>{' '}
                diseñada para acompañarte en momentos de pausa, introspección y
                claridad interior.
              </p>
              <p className="text-white/70" data-id="element-651">
                Dependiendo del acceso elegido, recibirás:
              </p>
            </div>

            {/* Mini icon list */}
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 max-w-2xl mx-auto text-left mb-2" data-id="element-652">
              {[{
              label: 'Libro principal',
              desc: 'Lectura guiada Código 888'
            }, {
              label: 'Archivos Maestros',
              desc: 'Material privado de introspección'
            }, {
              label: 'Protocolos de lectura',
              desc: 'Rituales de enfoque interior'
            }, {
              label: 'Audios inmersivos',
              desc: 'Sesiones guiadas de presencia'
            }, {
              label: 'Sala privada VIP',
              desc: 'Meditación y calma extendida'
            }, {
              label: 'Acceso digital inmediato',
              desc: 'Disponible desde cualquier dispositivo'
            }].map(item => <li key={item.label} className="flex items-start gap-3 bg-[#0A0A0B] border border-gold/15 rounded-xl p-4 hover:border-gold/30 transition-colors duration-300" data-id="element-653">
                  <span className="shrink-0 mt-0.5 flex items-center justify-center w-7 h-7 rounded-full border border-gold/30 bg-gold/5 text-gold" data-id="element-654">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" data-id="element-655">
                      <path d="M2.5 6.5L5 9L9.5 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-656" />
                    </svg>
                  </span>
                  <div data-id="element-657">
                    <p className="text-white text-sm font-bold leading-tight" data-id="element-658">
                      {item.label}
                    </p>
                    <p className="text-white/55 text-xs sm:text-sm leading-relaxed mt-0.5" data-id="element-659">
                      {item.desc}
                    </p>
                  </div>
                </li>)}
            </ul>
          </div>

          <div className="relative aspect-video rounded-2xl overflow-hidden" data-id="element-660">
            <div className="absolute inset-0 bg-gold/20 blur-[100px] rounded-full" data-id="element-661" />
            <video src="https://cdn.shopify.com/videos/c/o/v/907e877aadc5408da793d66cb072d484.mp4" autoPlay muted loop playsInline preload="metadata" aria-label="El Código 888 Sistema" className="relative z-10 w-full h-full object-cover drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-662" />
          </div>
        </motion.div>
      </div>
    </section>;
}